import { TextField, Typography } from '@mui/material';
import AutoComplete from '../../../components/FormInputs/autocompletes/Autocomplete/AutoComplete';
import { useListPick } from '../../../components/ListPicker/useListPick';
import LangEnum from '../../../lang/LangEnum';
import teceoInputConfig from '../../../utils/TeceoInputConfig';
import { onScrollEndReload } from '../../../utils/generics';
import { Catalog } from '../../catalogs/catalog.types';
import { useTranslation } from '../../translation/TranslationContext';
import { useSharedEntitiesStyles } from '../styles/sharedEntities.styles';

interface ICatalogAutocomplete {
  disabledListPick?: boolean;
  filter: Record<string, any>;
  onChange: (params: { id: string; name: string }) => void;
}

const CatalogAutocomplete = ({ onChange, disabledListPick, filter }: ICatalogAutocomplete) => {
  const { translate } = useTranslation();
  const { classes } = useSharedEntitiesStyles();
  const listPickActions = useListPick<Catalog>({
    url: `/catalogs`,
    order: { name: 'ASC' },
    defaultQuery: filter,
    queryField: 'query',

    disabled: disabledListPick,
  });

  const catalogs = listPickActions.leftItems;

  const handleChangeField = (value: Catalog) => {
    onChange({ id: value.id, name: value.name });
  };

  return (
    <AutoComplete<Catalog>
      options={catalogs}
      onInputChangeDelayed={listPickActions.onSearch}
      getOptionLabel={(option: Catalog) => {
        return option.name;
      }}
      onChange={(_, value: NonNullable<string | Catalog> | (string | Catalog)[] | null) =>
        handleChangeField(value as Catalog)
      }
      loading={listPickActions.loading}
      className={classes.autocomplete}
      tagClasses={classes.optionTag}
      slotProps={{
        listbox: {
          style: {
            maxHeight: 248,
          },
          onScroll: (event: React.SyntheticEvent) => onScrollEndReload(event, listPickActions),
        },
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder={translate(LangEnum.GLOBAL_SELECT_CATALOG)}
          variant="outlined"
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: null,
            },
          }}
        />
      )}
      {...teceoInputConfig}
      renderOption={(option: Catalog) => {
        return <Typography>{option.name}</Typography>;
      }}
    />
  );
};

export default CatalogAutocomplete;
